<template>
<div class="daoh2">
    <div class="ti">
       <transition>
        <keep-alive>
            <router-view ></router-view>
        </keep-alive>
       </transition>
    </div>
</div>
</template>
<script>
export default {
  name: 'ContractIndex',
  data () {
    return {

    }
  },
  //界面没出来前加载
  created() {

  }
}
</script>
<style scoped>
.daoh2{
    display: flex;
    height: 100%;
}
 .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100px;
    height: 100%;
  }
  a{
      text-decoration: none;
   }
   .ti{
    height: 100%;
    width: 100%;
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/index.vue